import config from 'crm/config'

const customerApi = `${config.apiHost}/oem-customer`

export default {
    getTableData: {
        url: `${customerApi}/api/channels`,
        type: 'GET',
    },
    // 下载导入模板
    downloadTemplate: {
        url: `${customerApi}/api/oem_miniso/channel_group_chat_link.xlsx`,
        type: 'GET',
    },
    // 导入文件
    importGroupLink: {
        url: `${customerApi}/api/oem_miniso/channel_group_chat_link/import`,
        type: 'POST',
    },
    // 下载门店链接模板
    downloadStoreGroupTemplate: {
        url: `${customerApi}/api/channel_store/group_link.xlsx`,
        type: 'GET',
    },
    // 导入门店链接文件
    importStoreGroup: {
        url: `${customerApi}/api/channel_store/group_link/import`,
        type: 'POST',
    },
}
